"use client"

import { useState, useEffect } from "react"

export function usePasswordCheck() {
  const [unlockedLessons, setUnlockedLessons] = useState(new Set())
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [subscriptionStatus, setSubscriptionStatus] = useState<string | null>(null)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch("/portal/api/check-auth.php", {
          credentials: "include", // Important: sends session cookies
        })
        const data = await response.json()

        console.log("[v0] usePasswordCheck - Full response:", data)
        console.log("[v0] usePasswordCheck - hasAccess:", data.hasAccess)
        console.log("[v0] usePasswordCheck - subscriptionStatus:", data.subscriptionStatus)

        setIsAdmin(!!data.isAdmin)

        if (data.hasAccess) {
          console.log("[v0] usePasswordCheck - User has access, subscription status:", data.subscriptionStatus)
          setIsAuthenticated(true)
          const stored = localStorage.getItem("techtok-unlocked-lessons")
          if (stored) {
            setUnlockedLessons(new Set(JSON.parse(stored)))
          }
        } else {
          console.log(
            "[v0] usePasswordCheck - User does NOT have access, subscription status:",
            data.subscriptionStatus,
          )
          setIsAuthenticated(false)
        }

        setSubscriptionStatus(data.subscriptionStatus || null)
      } catch (error) {
        console.error("[v0] usePasswordCheck - Failed to check authentication:", error)
      } finally {
        setIsLoading(false)
      }
    }

    checkAuth()
  }, [])

  const checkPassword = (password, lessonId) => {
    if (isAuthenticated) {
      const newUnlocked = new Set([...Array.from(unlockedLessons), lessonId])
      setUnlockedLessons(newUnlocked)
      localStorage.setItem("techtok-unlocked-lessons", JSON.stringify(Array.from(newUnlocked)))
      return true
    }

    window.location.href = "/portal/login.php"
    return false
  }

  const isLessonUnlocked = (lessonId) => {
    if (isAuthenticated) return true

    return unlockedLessons.has(lessonId)
  }

  return {
    checkPassword,
    isLessonUnlocked,
    isAuthenticated,
    isLoading,
    subscriptionStatus,
    isAdmin,
  }
}
